import React from 'react';
import {Input, Grid} from 'semantic-ui-react';
import {FormattedMessage, FormattedNumber} from 'react-intl';
import {shape, oneOf, number, bool, func, string} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {StoreStockFormModes, RetailerItemPropType} from '../utils';

const Row = ({label, value}) => (
  <Grid.Row columns={2}>
    <Grid.Column>
      {label}
    </Grid.Column>
    <Grid.Column>
      {value}
    </Grid.Column>
  </Grid.Row>
);

const CalculationsByMode = {
  [StoreStockFormModes.Increase]: (budget, cost, amount) => budget - (cost * amount),
  [StoreStockFormModes.Decrease]: (budget, cost, amount) => budget + (cost * amount)
};

export default class StoreStockModal extends React.Component {
  static propTypes = {
    mode: oneOf(Object.keys(StoreStockFormModes)).isRequired,
    currency: string.isRequired,
    availableBudget: number.isRequired,
    reward: RetailerItemPropType.isRequired,
    isOpen: bool,
    isInFlight: bool,
    onClose: func.isRequired,
    onSubmit: func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen && !this.props.isOpen) {
      // reset from initial state each time this modal opens, so as not to show stale values/validations.
      this.setState(this.initialState);
    }
  }

  get initialState() {
    return {
      value: '',
      nextBudget: this.props.availableBudget
    };
  }

  get canSubmit() {
    return this.state.value > 0 && this.state.nextBudget >= 0;
  }

  get actions() {
    return [
      {
        displayType: 'menu-item',
        action: this.props.onClose,
        isDisabled: this.props.isInFlight,
        label: <FormattedMessage id='rewardsStore.modal.storeStock.button.cancel' />
      },
      {
        displayType: 'button',
        primaryCheck: true,
        action: () => this.props.onSubmit(this.props.reward.id, this.state.value),
        isDisabled: !this.canSubmit,
        loading: this.props.isInFlight,
        label: <FormattedMessage id='rewardsStore.modal.storeStock.button.submit' />
      }
    ];
  }

  handleValueChange = (event, {value}) => {
    value = Number(value);

    const getBudget = CalculationsByMode[this.props.mode];
    const nextBudget = getBudget(this.props.availableBudget, this.props.reward.cost, value);

    this.setState({
      value,
      nextBudget
    });
  };

  render() {
    return this.props.mode && (
      <BasicModal
        header={(
          <FormattedMessage
            id={`rewardsStore.modal.storeStock.header.${this.props.mode.toLowerCase()}`} />
        )}
        specialType='primary-modal fadeInUp animResponse store-stock-modal'
        dimmer='inverted'
        modalSize='tiny'
        open={this.props.isOpen}
        closeOnDimmerClick={true}
        onClose={this.props.onClose}
        actions={this.actions}>
        <Grid>
          <Row
            label={this.props.reward.title}
            value={(
              <Input
                type='number'
                value={this.state.value}
                onChange={this.handleValueChange} />
            )} />
          <Row
            label={<FormattedMessage id='rewardsStore.modal.storeStock.label.availableBudget' />}
            value={(
              <FormattedNumber
                style='currency'
                currency={this.props.currency}
                value={this.state.nextBudget} />
            )} />
        </Grid>
      </BasicModal>
    );
  }
};



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsTable/StoreStockModal.jsx